import { RootState } from 'duck/store'
import { createSelector } from 'reselect'

import { getDataState } from '../selectors'
import { PEOPLE_STORE_ID, Person, Position } from './types'

const getPeopleState = createSelector(getDataState, (dataState) => dataState[PEOPLE_STORE_ID])

export const getPeople = createSelector(getPeopleState, (peopleState) => peopleState.items)

export const getPeopleArray = createSelector(getPeople, (people) => Object.values(people))

export const getPeopleEmails = createSelector(getPeople, (people) =>
  Object.keys(people).map((personId: string) => people[personId].email)
)

export const getPerson = (state: RootState, personId: Person['id'] | undefined | null) => {
  if (!personId) {
    return undefined
  }
  return createSelector(getPeople, (people) => people[personId])(state)
}

export const getIsFetchingPeople = createSelector(getPeopleState, (peopleState) => peopleState.isFetching)

export function getPersonFromPosition({ person }: Pick<Position, 'person'>) {
  return person
}

export function getRoleFromPosition({ title }: Pick<Position, 'title'>) {
  return title
}

export function getLinkedinUrlFromPerson({ linkedinUrl }: Pick<Person, 'linkedinUrl'>) {
  return linkedinUrl
}

export function getFullNameFromPerson({ firstName, lastName }: Pick<Person, 'firstName' | 'lastName'>) {
  return `${firstName || ''}${lastName ? ` ${lastName}` : ''}`
}
